<template>
  <i-container class="_align-self:stretch">
    <i-row am-sing-up-row around middle>
      <i-column lg="4" md="6" sm="7">

        <i-card>
          <template #header>Sign Up</template>

          <i-form @submit="onSubmit" v-model="form">
            <i-form-group>
              <i-form-label>Name</i-form-label>
              <i-input name="name" type="text" />
              <div am-error-field>
                <i-form-error for="name" />
              </div>
            </i-form-group>
            <i-form-group>
              <i-form-label>Email</i-form-label>
              <i-input name="email" />
              <div am-error-field>
                <i-form-error for="email" />
              </div>
            </i-form-group>
            <i-form-group class="_margin-bottom:2">
              <i-form-label>Invite code</i-form-label>
              <i-input disabled v-model="invite_code" />
            </i-form-group>
            <i-form-group>
              <i-form-label>Password</i-form-label>
              <i-input autocomplete="off" name="password" type="password" />
              <div am-error-field>
                <i-form-error for="password" />
              </div>
            </i-form-group>
            <i-form-group class="_display:flex _justify-content:space-between _align-items:center">
              <router-link link color="primary" class="_padding-left:0" to="/">Sign In</router-link>
              <i-button
                type="submit"
                :loading="loading"
                :disabled="form.untouched || form.touched && form.invalid"
                :color="form.untouched || form.touched && form.invalid ? '' : 'primary'"
              >
                Submit
              </i-button>
            </i-form-group>

          </i-form>

        </i-card>

      </i-column>
    </i-row>
  </i-container>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'SignUpView',
  data () {
    return {
      form: this.$inkline.form({
        name: {
          validators: [
            { name: 'required' }
          ]
        },
        email: {
          validators: [
            { name: 'required' },
            { name: 'email' }
          ]
        },
        password: {
          validators: [
            { name: 'required' },
            {
              name: 'minLength',
              value: 8
            }
          ]
        }
      }),
      loading: false,
      invite_code: null
    }
  },
  mounted () {
    this.invite_code = this.$route.params.code
  },
  methods: {
    ...mapMutations('notifications', ['addNotification']),
    onSubmit () {
      this.loading = true
      const user = {
        name: this.form.name.value,
        email: this.form.email.value,
        password: this.form.password.value,
        invite_code: this.invite_code
      }
      this.$store.dispatch('register', user)
        .then(() => {
          this.loading = false
          this.$router.push('/wear-select')
          this.addNotification({
            notification: {
              type: 'info',
              message: 'Logged in'
            }
          })
        })
        .catch(err => {
          this.loading = false
          const notification = { type: 'danger', text: null }
          if (err.body.errors) {
            for (const key in err.body.errors) {
              err.body.errors[key].forEach(el => {
                notification.message = el
                this.addNotification({ notification })
              })
            }
          } else {
            if (err.info.status >= 500) {
              notification.message = 'Internal server error, please try again later'
            } else if (err.info.status === 404) {
              notification.message = 'Server unavailable, please try again later'
            } else if (err.info.status === 403) {
              notification.message = 'Incorrect invite code'
            } else {
              notification.message = `${err.info.status}: ${err.info.statusText}`
            }
            this.addNotification({ notification })
          }
        })
    }
  }
}
</script>

<style lang="scss">
  [am-sing-up-row] {
    height: 100%;
    [am-error-field] {
      height: 15px;
      margin-top: 4px;
      .form-error li {
        display: none;
        &:first-child {
          display: block;
        }
      }
    }
  }
</style>
